import { Formik } from "formik";
import moment from "moment/moment";
import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { eventsActions } from "../../../store/events/eventsSlice";
const RegisterModal = () => {
  let defaultTotal = "Select a time to see the fee";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [streamSelected, setStreamSelected] = useState({});
  const [total, setTotal] = useState(defaultTotal);
  const [ageCategorySelected, setAgeCategorySelected] = useState({});
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const event = useSelector((state) => state.events.event);
  const selectedChoice = useSelector((state) => state.events.selectedChoice);

  const handleClose = () => {
    dispatch(eventsActions.removeEvent());
  };

  const getSlotLabel = (t) => {
    /**
     * Make the label based on:
     * <Date (Range)> @ <Time>
     *
     */

    let label = "";

    if (t.timeSlotLabel) {
      label += ` ${t.timeSlotLabel.toUpperCase()}`;
    }

    if (moment(t.startDate).isSame(t.endDate)) {
      label += `${moment(t.startDate, "YYYY-MM-DD").format(
        "ddd MMM DD"
      )} @ ${moment(t.startTime, "HH:mm:ss").format("hh:mm a")} - ${moment(
        t.endTime,
        "HH:mm:ss"
      ).format("hh:mm a")}`;
    } else {
      label += `${moment(t.startDate, "YYYY-MM-DD").format(
        "ddd DD MMM"
      )} - ${moment(t.endDate, "YYYY-MM-DD").format("ddd MMM DD")} @ ${moment(
        t.startTime,
        "HH:mm:ss"
      ).format("hh:mm a")} - ${moment(t.endTime, "HH:mm:ss").format(
        "hh:mm a"
      )}`;
    }

    return label;
  };

  return (
    Object.keys(event).length > 0 && (
      <Modal
        show={
          Object.keys(event).length > 0 &&
          Object.keys(selectedChoice).length === 0
        }
        onHide={handleClose}
      >
        <Modal.Header>
          <Modal.Title>Select a Time</Modal.Title>
        </Modal.Header>
        <div className="container">
          <Formik
            initialValues={{
              streamId: 0,
              ageCategoryId: 0,
              eventTimeSlotsId: 0,
            }}
            onSubmit={(values) => {
              dispatch(eventsActions.setEventChoice(values));
              if (!isLoggedIn) {
                navigate("/login");
              }
            }}
          >
            {({ values, setFieldValue, handleSubmit }) => (
              <>
                <Modal.Body>
                  <Form>
                    <div className="row">
                      <label>Stream</label>
                      <select
                        name="streamId"
                        className="form-select"
                        value={values.streamId}
                        onChange={(e) => {
                          setFieldValue("streamId", parseInt(e.target.value));
                          setFieldValue("ageCategoryId", 0);
                          setFieldValue("eventTimeSlotsId", 0);
                          let newStream = event.streams.filter((s) => {
                            return s.streamId === parseInt(e.target.value);
                          })[0];

                          setStreamSelected(newStream);
                        }}
                      >
                        <option value={0}>Select A Stream...</option>
                        {event.streams.map((s) => {
                          return (
                            <option key={s.streamId} value={s.streamId}>
                              {s.streamName.toUpperCase()}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="row">
                      <label>Age Categories</label>
                      <select
                        name="ageCategoryId"
                        className="form-select"
                        disabled={values.streamId === 0}
                        value={values.ageCategoryId}
                        onChange={(e) => {
                          setFieldValue(
                            "ageCategoryId",
                            parseInt(e.target.value)
                          );
                          setFieldValue("eventTimeSlotsId", 0);
                          let newAC = streamSelected.age_categories.filter(
                            (s) => {
                              return (
                                s.ageCategoryId === parseInt(e.target.value)
                              );
                            }
                          )[0];
                          setAgeCategorySelected(newAC);
                        }}
                      >
                        <option value={0}>Select An Age Categories...</option>
                        {streamSelected &&
                          Object.keys(streamSelected).length > 0 &&
                          streamSelected.age_categories.map((a) => {
                            return (
                              <option
                                key={a.ageCategoryId}
                                value={a.ageCategoryId}
                              >
                                {a.ageCategoryName.toUpperCase()}
                                {` (${moment(new Date()).diff(
                                  moment(a.times[0].startDob, "YYYY-MM-DD"),
                                  "years"
                                )} - ${moment(new Date()).diff(
                                  moment(a.times[0].endDob, "YYYY-MM-DD"),
                                  "years"
                                )} yrs old)`}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                    <div className="row">
                      <label>Time Slots</label>
                      <select
                        name="eventTimeSlotsId"
                        className="form-select"
                        value={values.eventTimeSlotsId}
                        disabled={values.ageCategoryId === 0}
                        onChange={(e) => {
                          setFieldValue(
                            "eventTimeSlotsId",
                            parseInt(e.target.value)
                          );
                          let fee =
                            parseInt(e.target.value) === 0
                              ? defaultTotal
                              : "$" +
                                ageCategorySelected.times.filter((t) => {
                                  return (
                                    t.eventTimeSlotsId ===
                                    parseInt(e.target.value)
                                  );
                                })[0].fee;
                          setTotal(`${fee}`);
                        }}
                      >
                        <option value={0}>Select An Time Slot...</option>
                        {ageCategorySelected &&
                          Object.keys(ageCategorySelected).length > 0 &&
                          ageCategorySelected.times.map((t) => {
                            return (
                              <option
                                key={t.eventTimeSlotsId}
                                value={t.eventTimeSlotsId}
                              >
                                {getSlotLabel(t)}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </Form>

                  <p>
                    <b>Team Size:</b>{" "}
                    {values.eventTimeSlotsId === 0
                      ? "Select a time slot"
                      : ageCategorySelected.times.filter((t) => {
                          return t.eventTimeSlotsId === values.eventTimeSlotsId;
                        })[0].teamMax ===
                        ageCategorySelected.times.filter((t) => {
                          return t.eventTimeSlotsId === values.eventTimeSlotsId;
                        })[0].teamMin
                      ? `${
                          ageCategorySelected.times.filter((t) => {
                            return (
                              t.eventTimeSlotsId === values.eventTimeSlotsId
                            );
                          })[0].teamMax
                        } member`
                      : `${
                          ageCategorySelected.times.filter((t) => {
                            return (
                              t.eventTimeSlotsId === values.eventTimeSlotsId
                            );
                          })[0].teamMin
                        } - ${
                          ageCategorySelected.times.filter((t) => {
                            return (
                              t.eventTimeSlotsId === values.eventTimeSlotsId
                            );
                          })[0].teamMax
                        } member(s)`}
                  </p>
                  <p>
                    <b>Registration Fee:</b> {total}{" "}
                    <small className="text-secondary">/per team</small>
                  </p>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={handleSubmit}>
                    Register
                  </Button>
                </Modal.Footer>
              </>
            )}
          </Formik>
        </div>
      </Modal>
    )
  );
};

export default RegisterModal;
